











































































































































































































































































































































import { Component, Mixins, Watch} from 'vue-property-decorator';
import { Job } from '@/@types/LibraryComponent';
import JobMiniCard from '@/components/jobList/table/JobMiniCard.vue';
import AccountIcon from '@/components/common/AccountIcon.vue';
import ActivityListDrawer from '@/components/common/ActivityListDrawer.vue';
import OrganizationIcon from '@/components/common/OrganizationIcon.vue';
import ProjectIcon from '@/components/common/ProjectIcon.vue';
import ProjectMenu from '@/components/common/CommonHeaderProjectMenu.vue';
import OrganizationMenu from '@/components/common/CommonHeaderOrganizationMenu.vue';
import { Auth } from 'aws-amplify';
import { vxm } from '@/store';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { FindNotificationsDto, Notification } from '@/@types/Notification';
import { NotificationKindCd } from '@/@types/constant';
import CreateDisplayMessage from '@/shared/CreateDisplayMessage';
import { AccountBasicParticipationProject, AccountParticipationOrganization } from '@/@types/Account';
import { ProjectMemberResponse } from '@/@types/ProjectMember';
dayjs.extend(relativeTime);

@Component({
  components: {
    JobMiniCard,
    AccountIcon,
    ActivityListDrawer,
    OrganizationIcon,
    ProjectIcon,
    ProjectMenu,
    OrganizationMenu
  },
})
export default class CommonHeader extends Mixins(CreateDisplayMessage) {
  public isProjectMenuRequired: boolean = false;
  private uploadIcon: string = require('../../assets/upload.png');
  private theoryLogo: string = require('../../assets/logotest.png');
  private loginUserName: string = 'セオリー太郎';
  private isOpenProjectList: boolean = false;
  private drawer: boolean = false;
  private jobs: Array<
    Job
  > = require('@/repository/mock/dummyData/job/jobList.json').jobs;
  private isHistoryJobsMenu: boolean = false;
  private isCuriousJobsMenu: boolean = false;
  private organizationAvatarSize: number = 32;
  private organizationAvatarColor: string = '#fdb44d';
  private projectAvatarSize: number = 32;
  private projectAvatarColor: string = '#fdb44d';
  private isOpenAddProject: boolean = false;
  private isProjectIconFileUploaded: boolean = false;
  private projectIconFileName: string = '';
  private projectName: string = '';
  private projectOverview: string = '';
  private projectIconURL: string = '';
  private projects: AccountBasicParticipationProject[] = [];
  private selectProjectMenberAccountId: number = 0;
  private searchNotifierWord: string = '';


  private async created() {
    /**routerの処理よりタイミングが早い場合があるので、対応用の処理を加えている */
    if (!this.accountId) {
      await vxm.theoryApi.authStore.fetchCurrentUserInfo();
    }
    const userInfo = vxm.theoryApi.authStore.getCurrentUserInfo?.results;
    if (userInfo) {
      const accountId = userInfo.accountId as number;
      const promises: Promise<void>[] = [];
      if (!this.organizationId) {
        vxm.theoryApi.authStore.fetchCurrentOrganizationId(userInfo.organizationId);
        if (!this.organizationId) {
          return;
        }
      }
      /**組織一覧を取得 */
      promises.push(
        vxm.theoryApi.accountsStore.fetchAccountParticipationOrganizations(
          accountId,
        ),
      );
      /**カレント組織のプロジェクト一覧を取得 */
      await vxm.theoryApi.accountsStore.fetchAccountBasicParticipationProjects({
        accountId: accountId,
        organizationId: this.organizationId,
      });
      const projectIds = this.participationProjects.map((project) => {
        return project.projectId;
      });
      const notificationParams: FindNotificationsDto = {
        notificationTargetAccountId: this.accountId as number,
        organizationId: this.organizationId,
        actionAccountId: 2,
        unreadFlag: true,
      };
      vxm.theoryApi.authStore.fetchCurrentProjectIds(projectIds);
      /**未読通知の一覧を取得 */
      promises.push(
        vxm.theoryApi.notificationsStore.fetchUnreadNotifications(notificationParams),
      );
      if (!this.projectId) {
          vxm.theoryApi.authStore.fetchCurrentProjectId(userInfo.projectId);
      }
      if (this.projectId) {
        promises.push(
          vxm.theoryApi.projectsStore.fetchProjectBasic(this.projectId),
        );
      }
      await Promise.all(promises);
      this.projects = this.participationProjects;
    }
  }

  private async isOpenNotificationMenu() {
    if (this.accountId) {
      const params: FindNotificationsDto = {
        notificationTargetAccountId: this.accountId,
        organizationId: this.organizationId,
        actionAccountId: 2,
      }
      await vxm.theoryApi.notificationsStore.fetchNotifications(params);
    }
  }

  private async openActivityListDrawer() {
    if (this.organizationId) {
        await vxm.theoryApi.activitiesStore.fetchOrganizationActivities({
        projectIds: this.projectIds,
        organizationId: this.organizationId
      });
    }
  }

  private clickProjectAddMenu(): void {
    this.isOpenAddProject = true;
    this.projectName = '';
    this.projectIconFileName = '';
    this.isProjectIconFileUploaded = false;
    this.projectOverview = '';
  }

  private openProjectIconExplorer(): void {
    const projectIconFile = this.$refs.projectIconFile as HTMLElement;
    projectIconFile.click();
  }

  private readProjectIconImage(event: Event): void {
    const target = event.target as HTMLInputElement;
    const files = target.files;
    if (!files!.length) {
      return;
    }
    this.projectIconURL = URL.createObjectURL(files![0]);
    this.isProjectIconFileUploaded = true;
    this.projectIconFileName = files!.item(0)!.name;
  }

  private deleteProjectIconFile(): void {
    this.isProjectIconFileUploaded = false;
    this.projectIconFileName = '';
  }

  private rules = {
    required: (value: string) => !!value || '必ず入力してください。',
    number: (value: string) => {
      const regexp = new RegExp(/^[0-9]+(\.[0-9]+)?$/);
      if (value.length > 0 && !regexp.test(value)) {
        return '数値を入力してください。';
      }
    },
    projectNameRule: (value: string) => {
      const projectIndexFound = this.projects.findIndex(
        (x) => x.title == value
      );
      if (projectIndexFound > -1) {
        return 'プロジェクト名が重複しています。プロジェクト名を変更してください。';
      }
    },
  };

  private moveToHome() {
    if (this.$route.name !== 'home') {
      this.$router.push({ name: 'home' });
    }
  }

  private addProjectName() {
    this.projects.splice(0);
    this.projects.push(...this.participationProjects);
  }

  private changeProjects() {
    this.projects.splice(0);
    this.projects.push(...this.participationProjects);
  }

  /**ログアウトテスト用 */
  private async onSignOut() {
    try {
      await Auth.signOut();
      this.$router.push({ name: 'login' });
    } catch (err) {
      console.log(err.code);
    }
  }

  private replaceMessage(message: string) {
    return message.replace(/\\n/g, '<br>');
  }

  private get notificationIconClass() {
    if (this.unreadNotifications.length > 0) {
      return {
        'notification-icon': true,
      };
    } else {
      return {
        'notification-icon': false,
      };
    }
  }

  private get notifications() {
    const response = vxm.theoryApi.notificationsStore.getNotifications;
    if (response) {
      return response.results;
    } else return [];
  }

  private get projectMenbers(): ProjectMemberResponse[] {
    const response = vxm.theoryApi.projectMembersStore.getHomeProjectMembers?.results ?? [];
    if (response) {
      return response;
    } else return [];
  }

  private get unreadNotifications() {
    const response = vxm.theoryApi.notificationsStore.getUnreadNotifications;
    if (response) {
      return response.results;
    } else return [];
  }

  private get participationProjects(): AccountBasicParticipationProject[] {
    const response = vxm.theoryApi.accountsStore.getAccountBasicParticipationProjects;
    if (response) {
      return response.results;
    } else return [];
  }

  private get participationOrganizations(): AccountParticipationOrganization[] {
    const response = vxm.theoryApi.accountsStore.getAccountParticipationOrganizations;
    if (response) {
      return response.results;
    } else return [];
  }

  private get accountId() {
    const response = vxm.theoryApi.authStore.getCurrentUserInfo;
    if (response) {
      return response.results.accountId;
    } else return null;
  }

  private get projectId() {
    return vxm.theoryApi.authStore.getCurrentProjectId;
  }

  private get organizationId() {
    return vxm.theoryApi.authStore.getCurrentOrganizationId;
  }

  private get projectIds() {
    return vxm.theoryApi.authStore.getCurrentProjectIds ? vxm.theoryApi.authStore.getCurrentProjectIds : [];
  }

  private get activities() {
    return vxm.theoryApi.activitiesStore.getOrganizationActivities
      ? vxm.theoryApi.activitiesStore.getOrganizationActivities.results
      : [];
  }

  private selectProjectMenber(accountId: number): void {
    this.selectProjectMenberAccountId = accountId;
  };

  private get selectedProjectMenber(): string {
    if (this.selectProjectMenberAccountId === 0) {
      return 'すべてのユーザー';
    }
    const selectedUser = this.projectMenbers.find(projectMenber => projectMenber.accountId === this.selectProjectMenberAccountId);
    return selectedUser ? `${selectedUser.accountName}` : '';
  };

  private get searchProjectMenbers(): ProjectMemberResponse[] {
    return this.projectMenbers.filter((projectMenber: { accountName: string|string[]; }) => projectMenber.accountName.indexOf(this.searchNotifierWord) !== -1);
  }
}
